import { Sparkles } from "lucide-react";

export const PatriciaWidget = () => {
  return (
    <button
      type="button"
      aria-label="Patricia, AI legal assistant, in development"
      className="group fixed bottom-20 right-4 z-[150] grid h-[52px] w-[52px] place-items-center rounded-full bg-foreground shadow-fab transition-all hover:scale-[1.06] hover:shadow-fab-hover md:bottom-8 md:right-8"
    >
      <span
        aria-hidden="true"
        className="absolute -right-0.5 -top-0.5 grid h-[17px] min-w-[17px] place-items-center rounded-full border-2 border-foreground bg-background px-1 text-[0.5rem] font-extrabold uppercase tracking-wider text-foreground"
      >
        Soon
      </span>
      <Sparkles className="h-5 w-5 text-background" strokeWidth={1.6} />
      <span className="pointer-events-none absolute right-[62px] top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-foreground px-3 py-1 text-xs text-background opacity-0 transition-opacity group-hover:opacity-100">
        Patricia, AI assistant, in development
      </span>
    </button>
  );
};
